import { Dialog, DialogProps } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { CloseButton } from '../../buttons';
import { ImageContainer } from '../../imageContainer';
import { SkodaScrollbars } from '../../scrollbars';

const useStyles = makeStyles({ name: 'DesktopImageDialog' })(theme => ({
	paper: {
		width: '100%',
		maxWidth: 'unset',
		height: '100%',
		maxHeight: 'unset',
		margin: 0,
		overflow: 'hidden',
		flexDirection: 'row',
		alignItems: 'stretch'
	},
	panelImage: {
		display: 'flex',
		flexBasis: '50%',
		position: 'relative'
	},
	image: {
		position: 'absolute',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0
	},
	panelContent: {
		boxSizing: 'border-box',
		flexBasis: '50%',
		padding: '30px 60px 45px 120px',
		[theme.originalBreakpoints.up('md')]: {
			padding: '130px 30px 70px 70px'
		},
		[theme.originalBreakpoints.up('lg')]: {
			padding: '130px 90px 130px 130px'
		}
	},
	paddingRight: {
		paddingRight: 60,
		[theme.originalBreakpoints.up('md')]: {
			paddingRight: 40
		},
		[theme.originalBreakpoints.up('lg')]: {
			paddingRight: 30
		}
	},
	close: {
		position: 'absolute',
		top: 20,
		right: 20,
		[theme.originalBreakpoints.up('md')]: {
			top: 30,
			right: 30
		}
	},
	contentWrapper: {
		position: 'relative',
		width: '100%',
		height: '100%'
	},
	scroll: {
		maxHeight: '100%',
		height: 'auto',
		position: 'absolute',
		left: 0,
		right: 0,
		top: '50%',
		transform: 'translateY(-50%)'
	}
}));

export type DesktopImageDialogClassKey = 'panelImage' | 'image' | 'panelContent' | 'paddingRight' | 'buttonClose';
export type DesktopImageDialogClasses = { [key in DesktopImageDialogClassKey]?: string };
export type DesktopImageDialogProps = DialogProps & {
	src: string;
	otherClasses?: DesktopImageDialogClasses;
};

export const ImageDialogDesktop: React.FC<DesktopImageDialogProps> = (props) => {
	const { src, open, onClose, classes, otherClasses, children, ...otherProps } = props;
	const { classes: styles, cx } = useStyles(undefined, { props: { classes: otherClasses } });

	return (
		<Dialog
			open={open}
			onClose={onClose}
			{...otherProps}
			classes={{
				...classes,
				paper: cx(styles.paper, classes?.paper)
			}}>

			<div className={styles.panelImage}>
				<ImageContainer
					className={styles.image}
					src={src} />
			</div>

			<div className={styles.panelContent}>
				<CloseButton
					onClick={() => onClose({}, 'backdropClick')}
					className={styles.close} />
				<div className={styles.contentWrapper}>
					<SkodaScrollbars className={styles.scroll}>
						<div className={styles.paddingRight}>
							{children}
						</div>
					</SkodaScrollbars>
				</div>
			</div>
		</Dialog>
	);
};
